const Environment = () => {
    var isLocalhost = Boolean(
        window.location.hostname === 'localhost' ||
        window.location.hostname === '[::1]' ||
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    var isQA = Boolean(
        window.location.href.match("source-qa") ||
        window.location.href.match("qa.")
    );

    var isSource = Boolean(
        window.location.href.match("source-")
    );

    return {
        isLocalhost: isLocalhost,
        isQA: isQA,
        isSource: isSource
    };
}
const switchURLapi = (LocalHost, QADomain, PRODDomain) => {
    if (Environment().isLocalhost) {
        return LocalHost;
    } else {
        if (Environment().isQA) {
            return QADomain;
        } else {
            if (Environment().isQA) {
                // if (Environment().isSource) {
                //     return QADomain.replace("qa-stories", "source-qa-stories")
                //         .replace("https:", "http:")
                // } else {
                    return QADomain;
                // }
            } else {
                // if (Environment().isSource) {
                //     return PRODDomain.replace("stories", "source-stories")
                //         .replace("https:", "http:")
                // } else {
                    return PRODDomain;
                // }
            }
        }
    }
}

const apiURL = switchURLapi("http://localhost:55773/api/",
    "http://source-qa.a.ynet.co.il/mLong/Commerce/2018/BringBringLead/api/",
    "https://z.ynet.co.il/mLong/Commerce/2018/BringBringAPI/api/");

export {
    Environment,
    apiURL
}


// WEBPACK FOOTER //
// ./src/Components/Services/baseURL.js